import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { usePaywallsAdminFormModal } from "./FormModal/";
import { PaymentProcessorStatus } from "./constants";

interface HeaderProps {
  paymentProcessorStatus: string;
  refetchPaywalls: () => void;
}

export const Header = ({
  paymentProcessorStatus,
  refetchPaywalls,
}: HeaderProps) => {
  const paywallsAdminHeader = usePaywallsAdminFormModal();

  const showPaywallsAdminFormModal = () =>
    paywallsAdminHeader.show({
      paywall: undefined,
      refetchPaywalls,
    });

  const enabledContent = (
    <div className="flex justify-between">
      <Typography.TitleSm weight="font-semibold">
        {t("settings.paywalls.title")}
      </Typography.TitleSm>
      <Button variant="circle" onClick={showPaywallsAdminFormModal}>
        {t("settings.paywalls.buttons.new")}
      </Button>
    </div>
  );

  const titleOnlyContent = (
    <div className="flex justify-between">
      <Typography.TitleSm weight="font-semibold">
        {t("settings.paywalls.title")}
      </Typography.TitleSm>
    </div>
  );

  const renderAccordingByPaymentProcessorStatus = {
    [PaymentProcessorStatus.ENABLED]: enabledContent,
  };

  const renderComponent =
    renderAccordingByPaymentProcessorStatus[paymentProcessorStatus] ??
    titleOnlyContent;

  return (
    <div className="bg-primary m-0 mb-12 mt-4 w-full rounded p-5">
      {renderComponent}
    </div>
  );
};
